import { useNavigate } from "react-router-dom";
import "./section2.css";
import Div1 from '../../img/Div1.svg';
import Div2 from '../../img/Div2.svg';
import Div3 from '../../img/Div3.svg';
import Div4 from '../../img/Div4.svg';



const Section2 = props => {
  const { country } = props
  const Navigate = useNavigate();
  return (
    <>
      {/* <img src="./assets/Line 1.svg" alt="" /> */}
      <div
        style={{
          backgroundImage: "url('/assets/Line 1.svg')", // Replace with your image path
          backgroundSize: "cover", // Makes the background image cover the whole div
          // backgroundPosition: "center", // Center-aligns the background image
          backgroundRepeat: "no-repeat", // Prevents the background from repeating
          // minHeight: "100vh",
          zIndex: "-1",
          // marginTop: "1.25rem",
          // marginBottom: "3rem",
        }}
      >
        <h2
          className="text-center secTwoHeading mb-8 px-16
        "
        // style={{
        //     fontSize:'48px',
        //     fontWeight:600,
        //     lineHeight:'57px',
        //     paddingTop:'4rem'
        // }}
        >
          How We operate: Our Online Assignment Help Service Workflow in {country}
        </h2>
        <div className="flex justify-center gap-2 align-center flex-wrap px-6">
          <div
            className="rounded-xl flex p-4 flex-col items-center largerScreen"
            style={{
              outline: "1px solid #DCDCDC",
              padding: "46px 24px",
              backgroundColor: "#fff",
            }}
          >
            <img
              src={Div1}
              className="w-[120px] h-[120px] rounded-full mb-2"
              alt="process"
            />

            <h2 className="font-bold mb-2">Submit Your Inquiry</h2>
            <p className="text-center">
              Fill in the inquiry form with the required details and our expert
              will connect immediately.
            </p>
          </div>

          <div
            className="rounded-xl flex p-4  flex-col items-center largerScreen"
            style={{
              outline: "1px solid #DCDCDC",
              padding: "46px 24px",
              backgroundColor: "#fff",
            }}
          >
            <img
              src={Div2}
              className="w-[120px] h-[120px] rounded-full mb-2"
              alt="process"
            />

            <h2 className="font-bold mb-2">Connect with Our Experts </h2>
            <p className="text-center">
              Our expert will further discuss and understand requirements,
              assist in the process and clarify all the necessary details.
            </p>
          </div>

          <div
            className="rounded-xl flex p-4  flex-col items-center largerScreen"
            style={{
              outline: "1px solid #DCDCDC",
              padding: "46px 24px",
              backgroundColor: "#fff",
            }}
          >
            <img
              src={Div3}
              className="w-[120px] h-[120px] rounded-full mb-2"
              alt="process"
            />

            <h2 className="font-bold mb-2">Proceed with Payment</h2>
            <p className="text-center">
              Make secured payments through different payment methods at your
              convenience.
            </p>
          </div>

          <div
            className="rounded-xl flex p-4  flex-col items-center largerScreen"
            style={{
              outline: "1px solid #DCDCDC",
              padding: "46px 24px",
              backgroundColor: "#fff",
            }}
          >
            <img
              src={Div4}
              className="w-[120px] h-[120px] rounded-full mb-2"
              alt="process"
            />

            <h2 className="font-bold mb-2">Get Your Solution</h2>
            <p className="text-center">
              Get your perfect solution delivered meeting your needs before the
              deadline.
            </p>
          </div>
        </div>
        <div className="my-16 text-center">
          <button
            // type="submit"
            className="w-auto text-[#fff] px-2 rounded-md bg-[#38419A]"
            style={{
              width: "200px",
              padding: "8px",
            }}
            onClick={() => Navigate('/contact-us')}
          >
            Book Our Services
          </button>
        </div>
        {/* <div className="text-center">
            <button className="text-[#fff]">

            Book Our Services
            </button>
        </div> */}
      </div>
    </>
  );
};

export default Section2;
